jQuery(function($){
  var ua = window.navigator.userAgent.toLowerCase();
  if(ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document){
    $('.collections_main_visual').addClass('no-fixed');
    $('.bg-fixed').addClass('no-fixed');
  }else{
    //$('.collections_main_visual').addClass('bg-fixed');
  }
});